// extracted by mini-css-extract-plugin
export default {"list":"MultiSelectList_list__vUyEO","itemWrapper":"MultiSelectList_itemWrapper__G3FRb","item":"MultiSelectList_item__ZRrhn"};